<button myToggleFullscreen="">
    <img [src]="isFullscreen ? '/assets/img/exit-fullscreen.png' : '/assets/img/enter-fullscreen.png'"/>
</button>
